import axios from "axios"

/**
 * « Ma dispo » (tutor self-service availability) — the semaine-type + freshness
 * endpoints. Every response is a TutorAvailabilityResource (week view), stored
 * in the `tutorAvailability` data reducer.
 *
 * The semaine-type is edited as a local draft and saved WHOLE by `confirmWeek`
 * (a replace-set), so there is no per-créneau write.
 */

function getAvailability() {
    return axios.get("/api/v1/tutor/availability")
}

function confirmWeek({}, data) {
    return axios.post("/api/v1/tutor/availability/confirm", data)
}

function updateStartingDate({}, data) {
    // { availability_starting_date: "YYYY-MM-DD" }
    return axios.put("/api/v1/tutor/availability/starting-date", data)
}

// « Libérer des créneaux »: the preview writes nothing, the release applies it.
function previewSlotRelease({}, data) {
    return axios.post("/api/v1/tutor/availability/release/preview", data)
}

function releaseSlots({}, data) {
    return axios.post("/api/v1/tutor/availability/release", data)
}

export const tutorAvailabilityService = {
    getAvailability,
    confirmWeek,
    updateStartingDate,
    previewSlotRelease,
    releaseSlots,
}
